/**
 * NOBL Air – How It Works
 * File: assets/nobl-air-how-it-works.js
 *
 * Responsibilities:
 *  1. Play / pause toggle via the custom play button
 *  2. Pause video when it scrolls out of view (Intersection Observer)
 *  3. Re-initialise cleanly in the Shopify Theme Editor
 */

(function () {
  'use strict';

  /* ── Constants ────────────────────────────────────────────── */
  const SECTION_SEL   = '.nobl_air_how_works';
  const WRAPPER_SEL   = '.nobl_air_how_works__video-wrapper';
  const VIDEO_SEL     = '.nobl_air_how_works__video';
  const PLAY_BTN_SEL  = '.nobl_air_how_works__play-btn';
  const PLAYING_CLASS = 'is-playing';

  /* ── Init one section ─────────────────────────────────────── */
  function initSection(section) {
    const wrapper = section.querySelector(WRAPPER_SEL);
    if (!wrapper) return;

    const video   = wrapper.querySelector(VIDEO_SEL);
    const playBtn = wrapper.querySelector(PLAY_BTN_SEL);
    if (!video) return;

    /* -- Unified toggle: works on play button AND video click - */
    function togglePlayback() {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    }

    if (playBtn) {
      playBtn.addEventListener('click', togglePlayback);
    }

    /* Click directly on the video to pause/resume */
    video.addEventListener('click', togglePlayback);

    /* -- Sync wrapper class with video state ----------------- */
    video.addEventListener('play',  () => wrapper.classList.add(PLAYING_CLASS));
    video.addEventListener('pause', () => wrapper.classList.remove(PLAYING_CLASS));
    video.addEventListener('ended', () => wrapper.classList.remove(PLAYING_CLASS));

    /* -- Pause when out of viewport -------------------------- */
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && !video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0.2 }
      );
      observer.observe(wrapper);

      /* Store reference so we can disconnect on section:unload */
      wrapper._noblObserver = observer;
    }
  }

  /* ── Init all sections on the page ───────────────────────── */
  function initAll() {
    document.querySelectorAll(SECTION_SEL).forEach(initSection);
  }

  /* ── Shopify Theme Editor events ──────────────────────────── */
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SEL);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    /* Clean up observers to avoid memory leaks */
    const wrapper = e.target.querySelector(WRAPPER_SEL);
    if (wrapper && wrapper._noblObserver) {
      wrapper._noblObserver.disconnect();
      delete wrapper._noblObserver;
    }
  });

  /* ── Boot ─────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();